module.exports = __webpack_public_path__ + "img/hotelFamily-3.8196c708.jpg";